/**
 * TELV1-551 — shared home for the redirect-scheme guard (moved from
 * apps/chat/src/utils/screeningRedirect.ts so the chatUI completion
 * path can use it too; the chat app re-exports it for its existing
 * call sites).
 *
 * Panel links are magic strings, not necessarily http(s) — custom app
 * schemes must pass. Only block schemes that would execute script on
 * redirect: a `javascript:` URL assigned to window.location runs in the
 * page's GLOBAL scope (Sentry TELLET-CHAT-G4 was exactly this, via a
 * project-configured completion link).
 */
// `blob:` included for defence in depth (release-3.11 review): blobs need
// same-origin creation so the risk is lower than `javascript:`, but a blob
// URL can still carry executable content and is never a legitimate panel
// link shape.
export const BLOCKED_REDIRECT_SCHEMES = /^\s*(javascript|data|vbscript|blob):/i;

export const sanitizeRedirectUrl = (url: string | null | undefined): string | null => {
  if (!url) return null;
  return BLOCKED_REDIRECT_SCHEMES.test(url) ? null : url;
};
